import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { AUTHGWCONSTANTS } from './authorization/authconstatnts';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  public static dialogResult = false;
  public static globalCartCounter = 0;
  public static globalCartPrice = 0;
  public static globalWishlistCounter = 0;
  public static addressChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  onOfflineCartReload = new BehaviorSubject<void>(null);
  onOnlineCartReload = new BehaviorSubject<void>(null);
  onOnlineWishlistReload = new BehaviorSubject<void>(null);
  headers: any;
  signinState$ = new BehaviorSubject<string>(null);
  otpState$ = new BehaviorSubject<string>(null);

  private priceFilterTrigger = new Subject<void>();
  priceFilter$ = this.priceFilterTrigger.asObservable();

  private filterButtonVisibility = new BehaviorSubject<boolean>(false);
  filterButtonVisible$ = this.filterButtonVisibility.asObservable();

  triggerPriceFilter(): void {
    this.priceFilterTrigger.next();
  }

  setFilterButtonVisibility(visible: boolean): void {
    this.filterButtonVisibility.next(visible);
  }

  private searchListSource = new BehaviorSubject<string[]>([]);
  searchList$ = this.searchListSource.asObservable();

  updateSearchList(list: string[]) {
    this.searchListSource.next(list);
  }

  constructor(private http: HttpClient) {}

  updateHeaders(): boolean {
    try {
      const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
      const guestAuth = localStorage.getItem(AUTHGWCONSTANTS.guestAuth);
      this.headers = { 'XEN-AUTHORIZATION': xenAuth ? xenAuth : guestAuth };
      this.headers = { ...this.headers, ...environment.platformInfo };
      return true;
    } catch {
      return false;
    }
  }

  getOffers(urlParam: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/components/offers', {
      headers: this.headers,
      params: urlParam,
    });
  }

  getGuestToken(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/guest/token');
  }

  getAddress(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/address/v3', {
      headers: this.headers,
    });
  }

  getServiceArea(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/service/area/selection', {
      headers: this.headers,
      params: urlParams,
    });
  }

  getProfile(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/profile', {
      headers: this.headers,
    });
  }

  getCarts(urlParam: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/online/customer_cart_v5', {
      headers: this.headers,
      params: urlParam,
    });
  }

  getWishlists(urlParam: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/v4/component/user/wishlist', {
      headers: this.headers,
      params: urlParam,
    });
  }

  getBusinessProfile(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/element/business/profile', {
      headers: this.headers,
    });
  }

  postWishlist(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/v4/component/user/wishlist', body, {
      headers: this.headers,
    });
  }

  postProductInCart(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/online/customer_cart_v5', body, {
      headers: this.headers,
    });
  }

  getParentCategories(): Observable<any> {
    return this.http.get<any>(`${environment.proxyApiUrl}/api/resource/parent/category`, {
      headers: this.headers,
    });
  }

  getProducts(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/v1/online/items/list', {
      headers: this.headers,
      params: urlParams,
    });
  }
}
